import React from 'react';
import { Form } from 'antd';
import { Input } from '@element/index';
import styles from './index.module.css'
import cn from 'classnames';

const FormItem = Form.Item;

export const FormInputNumber = (props) => {
  const { name, suffix, prefix, rules, onChange, onFocus, fieldValid = {} } = props;
  return (
    <FormItem className={styles.formItem} shouldUpdate={(prevValues, curValues) => prevValues[name] !== curValues[name]}>
      {(form) => {
        return (
          <FormItem {...fieldValid} name={name} rules={rules}>
            <Input
              placeholder=" "
              type={'number'}
              inputMode="decimal"
              className={styles.input}
              suffix={<span className={cn(styles.suffix, 'DINPro-Medium')}>{suffix}</span>}
              prefix={<span className={styles.prefix}>{prefix}</span>}
              value={form.getFieldValue(name)}
              onFocus={onFocus ? () => onFocus(name) : null}
              onChange={onChange}
              onInput={(e) => {
                const value = e.target.value;
                if (value.indexOf('.') !== -1) {
                  const [first, ...rest] = value.split('.');
                  e.target.value = `${first}.${rest.join('')}`
                }
              }}
              onPaste={e => {
                e.preventDefault();
              }}
              onKeyDown={(e) => {
                if (e.key === '-' || e.key === 'e') {
                  e.preventDefault();
                }
              }}
            />
          </FormItem>
        )
      }}
    </FormItem>
  )
}
